import { useEffect, useState } from "react";
import { getSessionUniversityId } from "../utils/sessionUser";

const useSelectedUniversity = () => {
  const [universityId, setUniversityId] = useState(() =>
    getSessionUniversityId(),
  );

  useEffect(() => {
    const sync = () => setUniversityId(getSessionUniversityId());
    window.addEventListener("universityChanged", sync);
    return () => window.removeEventListener("universityChanged", sync);
  }, []);

  return universityId;
};

export default useSelectedUniversity;